export default class DOMArticle extends Phaser.GameObjects.DOMElement{
    constructor(scene, x, y, width) {
        super(scene, x, y)
        scene.add.existing(this);

        this.setOrigin(0)

        this.scene = scene;

        this.createFromHTML('<iframe src="assets/iframe/article/index.html" frameborder="0" style="width: 100%;height: 100%;overflow: hidden;"></iframe></iframe>');

        this.style = this.node.style
        this.style.width = "1006px"
        this.style.height = "796px"
        // this.style.overflow = "auto"
        this.updateSize()

    }

}